<template>
  <v-dialog v-model="internalShow" persistent max-width="350">
    <v-card>
      <v-toolbar flat color="primary" dark>
        <v-toolbar-title>Enter Your PIN</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon @click="close">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>

      <v-container grid-list-lg>
        <v-card-text class="text-center">
          <!-- ✅ 4 PIN boxes -->
          <div class="d-flex justify-center mb-3">
            <div
              v-for="i in 4"
              :key="i"
              class="pin-box"
              :class="{ filled: i <= entered.length }"
            >
              <span v-if="i <= entered.length">•</span>
            </div>
          </div>

          <!-- ✅ Keypad -->
          <div class="d-flex flex-wrap justify-center mt-3">
            <v-btn
              v-for="n in 9"
              :key="n"
              color="primary"
              class="ma-1"
              width="70"
              height="60"
              @click="addDigit(n)"
              >{{ n }}</v-btn
            >

            <v-btn
              color="primary"
              class="ma-1"
              width="70"
              height="60"
              @click="addDigit(0)"
              >0</v-btn
            >

            <v-btn
              color="error"
              class="ma-1"
              width="70"
              height="60"
              @click="clear"
            >
              Clear
            </v-btn>
          </div>
        </v-card-text>
      </v-container>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "PinVerificationDialog",
  props: {
    value: { type: Boolean, required: true },
    employee: { type: Object, default: () => ({}) },
  },
  data() {
    return {
      internalShow: this.value,
      entered: "",
      loading: false,
    };
  },
  watch: {
    value(val) {
      this.internalShow = val;
    },
    internalShow(val) {
      this.$emit("input", val);
    },
  },
  methods: {
    addDigit(n) {
      if (this.entered.length < 4) {
        this.entered += n.toString();

        // 🟢 Auto-submit once 4 digits entered
        if (this.entered.length === 4) {
          this.submit();
        }
      }
    },
    clear() {
      this.entered = "";
    },
    async submit() {
      const pin = this.entered.trim();
      if (pin.length !== 4) return;

      this.loading = true;

      try {
        const result = await this.$emit("verifyPin", pin);
        if (result === false) throw new Error("Invalid PIN");

        // this.$toast.success("PIN verified", {
        //   timeout: 1500,
        //   pauseOnHover: false,
        // });
        this.close();
      } catch (e) {
        this.$toast.error("Invalid PIN. Please try again.", {
          timeout: 1500,
          pauseOnHover: false,
        });
        this.clear();
      } finally {
        this.loading = false;
      }
    },
    close() {
      this.entered = "";
      this.internalShow = false;
      this.$emit("input", false);
      this.$emit("close");
    },
  },
};
</script>

<style scoped>
.pin-box {
  width: 40px;
  height: 45px;
  border: 2px solid #ccc;
  border-radius: 8px;
  margin: 0 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 26px;
  font-weight: bold;
  color: #333;
  transition: border-color 0.2s;
}
.pin-box.filled {
  border-color: #1976d2;
  background-color: #e3f2fd;
}
</style>